import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { useFetchCentralAssortmentMemberViewFilterOptions } from '@retail/my-assortment/data-access';
import { AssortmentTag } from '@retail/my-assortment/types';
import { AssortmentTagTable } from '@retail/products/components';
import { SupplierItemWithAssortmentTags } from '@retail/products/types';
import { useMemo } from 'react';
import { useFetchSupplierItemAssortmentTags } from '@retail/products/data-access';

interface Props {
  mgItemNumber: number;
}

export function MemberAssortmentTags({ mgItemNumber }: Props) {
  const { assortmentId } = useSelectedOrgUnit();

  const { data: itemAssortmentTagsDTO } = useFetchSupplierItemAssortmentTags({
    mgItemNumber,
    assortmentId,
  });

  const supplierItemsWithTags = useMemo(
    () => itemAssortmentTagsDTO?.mgSupplierItems.map(SupplierItemWithAssortmentTags.fromDto) ?? [],
    [itemAssortmentTagsDTO?.mgSupplierItems]
  );

  // Members only see the brand's sub-assortments that are made visible to them
  const { data: filterOptions } = useFetchCentralAssortmentMemberViewFilterOptions({
    assortmentId,
  });
  const assortmentTags = useMemo(
    () => filterOptions?.assortmentTags?.map(AssortmentTag.fromDTO) ?? [],
    [filterOptions?.assortmentTags]
  );

  const sortedSupplierItems = [...supplierItemsWithTags].sort((a, b) => {
    return a.supplier.name.localeCompare(b.supplier.name, 'no', { sensitivity: 'base' });
  });

  return (
    <AssortmentTagTable
      supplierItemsTags={sortedSupplierItems}
      assortmentTags={assortmentTags}
      readOnly
    />
  );
}
